import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SortField } from '../../../../generic/classes/sortfield';
import { SortComponent } from '../../../../generic/component/sort/sort.component';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'history-order-detail-sort',
    templateUrl: 'history.detail.sort.component.html',
    standalone: true,
    imports: [FormsModule],
})
export class HistoryDetailSortComponent
    extends SortComponent
    implements OnInit {
    activeSortFieldKeyAndOrder: string;
    @Output() sortChangeEvent = new EventEmitter();
    @Input() labelSortDescription: string;
    @Input() labelSortVolume: string;
    @Input() labelSortPrice: string;

    constructor() {
        super();
        this.activeSortFieldKeyAndOrder = 'productDescription|ASC';
    }

    getActiveSortFieldKey(): string {
        return this.activeSortFieldKeyAndOrder.split('|')[0];
    }

    getActiveSortFieldDirection(): string {
        return this.activeSortFieldKeyAndOrder.split('|')[1];
    }

    getSortFields(): SortField[] {
        return [
            new SortField(
                'productDescription',
                this.labelSortDescription,
                true,
                false,
            ),
            new SortField('volume', this.labelSortVolume, true, false),
            new SortField('previousPrice', this.labelSortPrice, true, false),
        ];
    }

    override ngOnInit(): void {
        super.ngOnInit();
    }

    onChangeActiveSortField() {
        this.setApplicableSortFields();

        this.sortChangeEvent.emit({
            key: this.getActiveSortFieldKey(),
            direction: this.getActiveSortFieldDirection(),
        });
    }
}
